<div class="full_screen_chart">
    <trading-chart [pair]="pair" [theme]="theme" [mobile]="mobile" [fullscreen]="fullscreen"></trading-chart>
</div>